import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import LeScoopBreadCrumbs from './le_scoop-breadcrumbs';

import isFullWidthBelowMedium from '../../utils/isFullWidthBelowMedium';
import isFullWidthMobileOnly from '../../utils/isFullWidthMobileOnly';
import isModuleBackgroundWhite from '../../utils/isModuleBackgroundWhite';
import hasHr from '../../utils/hasHr';
import { Content } from '../../theme/page';
import getModuleTemplates from '../../utils/cms/getModuleTemplates';

const isCircleBanner = (modulename) => modulename === 'circle_banner';
const isDoubleBanner = (modulename) => modulename === 'double_banner';
const isAccordion = (modulename) => modulename === 'accordion';
const isSocialShare = (modulename) => modulename === 'social_share';
const isBlockQuote = (modulename) => modulename === 'block_quote';
const isCategoryTaxonShop = (modulename) => modulename === 'category_taxon_shop';

const PageModules = ({
  page, modules, category, subcategory
}) => {
  const router = useRouter() ?? {};
  const templates = getModuleTemplates(modules);

  return (
    <section>
      <LeScoopBreadCrumbs category={category} subcategory={subcategory} path={router.asPath} />
      {
        templates?.length > 0 && (
          templates.map((template, index) => {
            const {
              Template,
              title,
              position,
              data
            } = template;
            return Object.keys(data ?? {}).length > 0 && (
              <Content
                className="cms-content"
                template={template}
                isCMS
                hasHr={hasHr(data)}
                isDoubleBanner={isDoubleBanner(title)}
                noPadding={title === 'markup'}
                key={`${page.id}-${title}-${position}`}
                isCircleBanner={isCircleBanner(title)}
                isWhite={isModuleBackgroundWhite(title)}
                isAccordion={isAccordion(title)}
                isSocialShare={isSocialShare(title)}
                isBlockQuote={isBlockQuote(title)}
                isNeon={page.Background === 'neon'}
                isFullWidthBelowMedium={isFullWidthBelowMedium(title)}
                isFullWidthMobileOnly={isFullWidthMobileOnly(title)}
                noEvents={isCategoryTaxonShop(title)}
                pillarNav={isCategoryTaxonShop(title)}
                pillarPadding={title === 'le_scoop'}
              >
                <Template
                  data={data}
                  disableLazyload={index < 2}
                  pillar
                />
              </Content>
            );
          })
        )
      }
    </section>
  );
};

PageModules.defaultProps = {
  category: null,
  subcategory: null
};

PageModules.propTypes = {
  page: PropTypes.object.isRequired,
  modules: PropTypes.array.isRequired,
  category: PropTypes.object,
  subcategory: PropTypes.object
};

export default PageModules;
